"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewGateway extends new_item_1.default {
    constructor(newGateway) {
        super();
        this.virtualFrom = newGateway.virtualFrom;
        this.updateState = newGateway.updateState;
        this.locationId = newGateway.locationId;
        this.locationName = newGateway.locationName;
        this.timezone = newGateway.timezone;
        this.locationMetadata = newGateway.locationMetadata;
        this.targetVersion = newGateway.targetVersion;
        if (!newGateway.name) {
            throw Error("name required");
        }
        this.name = newGateway.name;
        this.scanning = newGateway.scanning;
        this.status = newGateway.status;
        this.physicalGatewayId = newGateway.physicalGatewayId;
        this.ethernetMac = newGateway.ethernetMac;
        this.wlanMac = newGateway.wlanMac;
        this.lastContacted = newGateway.lastContacted;
        this.siteId = newGateway.siteId;
        this.siteName = newGateway.siteName;
        this.connectionType = newGateway.connectionType;
        this.powerSource = newGateway.powerSource;
        this.charge = newGateway.charge;
        this.wifiNetwork = newGateway.wifiNetwork;
        this.activeConnection = newGateway.activeConnection;
        this._permission = newGateway._permission;
        this.wifiStrength = newGateway.wifiStrength;
        this.mobileStrength = newGateway.mobileStrength;
        this.imsi = newGateway.imsi;
        this.ipAddress = newGateway.ipAddress;
        this.serialNumber = newGateway.serialNumber;
        this.modelNumber = newGateway.modelNumber;
        this.disconnected = newGateway.disconnected;
        this.staging = newGateway.staging;
        this.beta = newGateway.beta;
        this.debugMode = newGateway.debugMode;
        this.enhancedLogging = newGateway.enhancedLogging;
        this.zigbeeDisabled = newGateway.zigbeeDisabled;
        this.doReboot = newGateway.doReboot;
        this.doZigbeeReset = newGateway.doZigbeeReset;
        this.getTrustedList = newGateway.getTrustedList;
        this.installationCode = newGateway.installationCode;
        this.version = newGateway.version;
        this.updateSlot = newGateway.updateSlot;
        this.type = newGateway.type;
        this.gatewayType = newGateway.gatewayType;
        this.imei = newGateway.imei;
        this.intermittent = newGateway.intermittent;
        this.lowSignal = newGateway.lowSignal;
        this.fault = newGateway.fault;
        this.anomaly = newGateway.anomaly;
    }
}
exports.default = NewGateway;
//# sourceMappingURL=new-gateway.js.map